<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :class="$isMobile ? 'text-body-2' : 'text-body-1'"
    class="primary-grey--text mt-3 psa-content-wrapper text-left"
  >
    <div
      class="mb-3"
      v-html="typedSections.psaIntro1"
    />

    <div
      class="mb-3"
      v-html="typedSections.psaIntro2"
    />

    <div class="pl-8">
      <div
        v-for="key in psaBulletKeys"
        :key="key"
        class="mb-2 d-flex"
        v-html="typedSections[key]"
      />
    </div>

    <div
      class="mt-6"
      v-html="typedSections.psaToolsIntro1"
    />
    <div
      class="mt-3 mb-3"
      v-html="typedSections.psaToolsIntro2"
    />

    <div class="pl-8">
      <div
        v-for="key in psaToolKeys"
        :key="key"
        class="d-flex align-start mb-2"
        v-html="typedSections[key]"
      />
    </div>

    <div
      class="mt-6 mb-2"
      v-html="typedSections.psaTip"
    />

    <div
      class="mb-2"
      v-html="typedSections.psaExample"
    />

    <div
      class="mt-3"
      v-html="typedSections.psaFeedback"
    />
  </div>
</template>

<script>
export default {
  name: 'SinoaPSAContent',

  props: {
    typedSections: {
      type: Object,
      required: true,
    },
  },

  computed: {
    psaBulletKeys() {
      return ['psaBullet1', 'psaBullet2', 'psaBullet3', 'psaBullet4'];
    },

    psaToolKeys() {
      return ['psaTool1', 'psaTool2', 'psaTool3', 'psaTool4'];
    },
  },
};
</script>

<style scoped>
.psa-content-wrapper {
  max-width: 90%;
  margin: 0 auto;
}
</style>
